import styled from 'styled-components';
export const FiltersContainer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;

export const OrderFilterBlock = styled.div<{ hasBilledTableType?: boolean }>`
  display: grid;
  grid-template-columns: ${({ hasBilledTableType }) =>
    hasBilledTableType
      ? 'minmax(0, 185px) 1fr 2fr minmax(0, 290px) minmax(0, 185px)'
      : 'minmax(0, 185px) 1fr 2fr minmax(0, 185px) 1fr'};

  margin-top: 1rem;

  align-items: start;
  justify-content: space-between;
  gap: 1rem;

  width: 100%;

  & > * {
    min-width: 0;
  }

  & > button {
    width: 186px;
    height: 48px;
    padding: 0;
    align-self: flex-end;
  }

  & > div.hefesto-datefield,
  div.select-container {
    min-width: 16.875rem;
    flex: 1;
  }

  & > div {
    &.order-status > .ant-select {
      width: 100%;

      & span.ant-select-selection-item > span.all {
        // esconde a bolinha no select fechado quando tiver selecionado a opção "Todos"
        display: none;
      }
    }

    &.product-type > .ant-select {
      width: 100%;
    }

    &.date-range {
      min-width: 15rem;
    }
  }

  ${({ hasBilledTableType, theme }) =>
    hasBilledTableType
      ? `
    @media (max-width: 1150px) {
    display: flex;
    flex-direction: column;
    > div {
      width: 100%;
    }
  }`
      : `@media (max-width: ${theme.breakpoints.tablet}) {
    display: flex;
    flex-direction: column;
    > div {
      width: 100%;
    }
  }`}

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    .select-container {
      min-width: 16.875rem;
    }
  }

  & > div {
    flex: 1;
    min-width: 200px;
  }
`;

export const CollorFulBall = styled.span`
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 5px;
  margin-right: 0.5rem;
`;

export const DateFieldWrapper = styled.div`
  > div:nth-child(2) {
    gap: 0;
    > .hefesto-input-wrapper {
      width: 145px;
    }
  }

  @media (max-width: 1150px) {
    display: flex;
    flex-direction: column;
    > div:nth-child(2) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0;
      > div.hefesto-input-wrapper {
        width: 100%;
      }
    }
  }
`;
